import styled, { css } from 'styled-components';
import { ApButtonMain, ApButtonLink } from '@alixpartners/ui-components';
import { greenDark, grey200 } from 'styles/colors';

export const FileDownloadContainer = styled.div`
	width: 100%;
	padding: 32px 40px;
`;

export const DownloadControlsSection = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 32px;
`;

export const LatestUpdateSection = styled.div`
	margin-bottom: 24px;
`;

export const DownloadButtonWrapper = styled.div`
	display: flex;
	flex-direction: row;
`;

export const ButtonMain = styled(ApButtonMain)`
	margin-bottom: 8px;

	&:last-child {
		margin-bottom: 0;
	}
`;

export const StyledButtonLink = styled(ApButtonLink)`
	margin-right: 32px;

	${({ disabled }) =>
		disabled &&
		css`
			pointer-events: none;

			svg {
				fill: ${grey200};
			}
		`};

	&:hover {
		color: ${greenDark};

		svg {
			fill: ${greenDark};
		}
	}
`;

export const ButtonWrapper = styled.div`
	margin-right: 35px;
`;

export const ScrollWrapper = styled.div`
	overflow: auto;

	& > div {
		min-width: 800px;
	}
`;
